import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadTOMultimediaListStatus: 'idle',
    loadTOMultimediaListError: undefined as any,
    loadTOMultimediaListLastArgs: undefined as any,
    loadTOMultimediaStatus: 'idle',
    loadTOMultimediaError: undefined as any,
    saveTOMultimediaStatus: 'idle',
    saveTOMultimediaError: undefined as any,
    deleteTOMultimediaStatus: 'idle',
    deleteTOMultimediaError: undefined as any,

    toMultimediaList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTOMultimediaList = createAsyncThunk('toMultimediaSlice/loadTOMultimediaList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toMultimediaSlice.loadTOMultimediaListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremmultimedia/?action=gte&MIN_MODULTYPE=3&MAX_MODULTYPE=3&MIN_MODULOBJID=${parentModel.HDR_ID}&MAX_MODULOBJID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOMultimediaListStatus } = getState().toMultimediaSlice
        return loadTOMultimediaListStatus !== 'pending'
    }
})

export const loadTOMultimedia = createAsyncThunk('toMultimediaSlice/loadTOMultimedia', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremmultimedia/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOMultimediaStatus } = getState().toMultimediaSlice
        return loadTOMultimediaStatus !== 'pending'
    }
})

export const saveTOMultimedia = createAsyncThunk('toMultimediaSlice/saveTOMultimedia', async ({ toMultimedia }: any, { rejectWithValue }: any) => {
    let promises = []
    if (toMultimedia?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ncremmultimedia/${ toMultimedia?.HDR_ID }/`,
            prepareData(toMultimedia),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ncremmultimedia/`,
            prepareData(toMultimedia),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveTOMultimediaStatus } = getState().toMultimediaSlice
        return saveTOMultimediaStatus !== 'pending'
    }
})

export const deleteTOMultimedia = createAsyncThunk('toMultimediaSlice/deleteTOMultimedia', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ncremmultimedia/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteTOMultimediaStatus } = getState().toMultimediaSlice
        return deleteTOMultimediaStatus !== 'pending'
    }
})

const ToMultimediaSlice = createSlice({
    name: 'toMultimediaSlice',
    initialState,
    reducers: {
        resetloadTOMultimediaListError: (state) => {
            state.loadTOMultimediaListError = undefined
        },
        resetloadTOMultimedia: (state) => {
            state.formItem = undefined
            state.loadTOMultimediaError = undefined
        },
        resetloadTOMultimediaError: (state) => {
            state.loadTOMultimediaError = undefined
        },
        resetsaveTOMultimedia: (state) => {
            state.formItem = undefined
            state.saveTOMultimediaError = undefined
        },
        resetsaveTOMultimediaError: (state) => {
            state.saveTOMultimediaError = undefined
        },
        resetdeleteTOMultimediaError: (state) => {
            state.deleteTOMultimediaError = undefined
        },
        removeFromToMultimediaListById: (state, action) => {
            state.toMultimediaList = state.toMultimediaList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromToMultimediaListByIds: (state, action) => {
            state.toMultimediaList = state.toMultimediaList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.toMultimediaList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTOMultimediaListStatus = 'preloaded'
            state.loadTOMultimediaListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.toMultimediaList = []
            state.loadTOMultimediaListStatus = 'idle'
            state.loadTOMultimediaListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTOMultimediaList.pending, (state) => {
            state.loadTOMultimediaListStatus = 'pending'
            state.loadTOMultimediaListError = undefined
        })
        builder.addCase(loadTOMultimediaList.fulfilled, (state, action) => {
            state.loadTOMultimediaListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTOMultimediaListLastArgs = action.payload.args

            {
                state.toMultimediaList = action.payload.data

            }
        })
        builder.addCase(loadTOMultimediaList.rejected, (state, action) => {
            state.loadTOMultimediaListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOMultimediaListError = action.error.message
            } else {
                state.loadTOMultimediaListError = action.payload
            }
        })

        builder.addCase(loadTOMultimedia.pending, (state) => {
            state.loadTOMultimediaStatus = 'pending'
            state.loadTOMultimediaError = undefined
        })
        builder.addCase(loadTOMultimedia.fulfilled, (state, action) => {
            state.loadTOMultimediaStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.toMultimediaList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.toMultimediaList.push(newItem) }
                else { state.toMultimediaList[i] = { ...state.toMultimediaList[i], ...newItem } }
            }
        })
        builder.addCase(loadTOMultimedia.rejected, (state, action) => {
            state.loadTOMultimediaStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOMultimediaError = action.error.message
            } else {
                state.loadTOMultimediaError = action.payload
            }
        })

        builder.addCase(saveTOMultimedia.pending, (state) => {
            state.saveTOMultimediaStatus = 'pending'
            state.saveTOMultimediaError = undefined
        })
        builder.addCase(saveTOMultimedia.fulfilled, (state, action) => {
            state.saveTOMultimediaStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.toMultimediaList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.toMultimediaList.push(newItem) }
                else { state.toMultimediaList[i] = { ...state.toMultimediaList[i], ...newItem } }
            }
        })
        builder.addCase(saveTOMultimedia.rejected, (state, action) => {
            state.saveTOMultimediaStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveTOMultimediaError = action.error.message
            } else {
                state.saveTOMultimediaError = action.payload
            }
        })

        builder.addCase(deleteTOMultimedia.pending, (state) => {
            state.deleteTOMultimediaStatus = 'pending'
            state.deleteTOMultimediaError = undefined
        })
        builder.addCase(deleteTOMultimedia.fulfilled, (state, action) => {
            state.deleteTOMultimediaStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.toMultimediaList = state.toMultimediaList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.toMultimediaList = state.toMultimediaList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteTOMultimedia.rejected, (state, action) => {
            state.deleteTOMultimediaStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteTOMultimediaError = action.error.message
            } else {
                state.deleteTOMultimediaError = action.payload
            }
        })

    }
})

export const {
    resetloadTOMultimediaListError,
    resetloadTOMultimedia,
    resetloadTOMultimediaError,
    resetsaveTOMultimedia,
    resetsaveTOMultimediaError,
    resetdeleteTOMultimediaError,
    removeFromToMultimediaListById,
    removeFromToMultimediaListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ToMultimediaSlice.actions
export default ToMultimediaSlice.reducer
